import { render, staticRenderFns } from "./Metrics.vue?vue&type=template&id=2a9c98aa&scoped=true&"
import script from "./Metrics.vue?vue&type=script&lang=js&"
export * from "./Metrics.vue?vue&type=script&lang=js&"
import style0 from "./Metrics.vue?vue&type=style&index=0&id=2a9c98aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9c98aa",
  null
  
)

export default component.exports